import { connect } from 'react-redux'
import { getAlerts, markAlertRead, clearAlert, clearAllAlerts } from './alerts.actions'
import Alerts from './Alerts'

const mapStateToProps = ({ alerts }) => {
  const { list, unreadCount, totalCount, pageSize, page, error } = alerts

  return {
    alerts: list,
    unread: unreadCount,
    total: totalCount,
    page: page + 1, // UI paging will be one-indexed
    pageSize,
    error,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSelectAlert(alert) {
    dispatch(markAlertRead(alert))
  },
  onRemoveAlert(alert) {
    dispatch(clearAlert(alert))
  },
  onChangePage(page) {
    const { itemsPerPage } = ownProps
    dispatch(getAlerts(page - 1, itemsPerPage)) // API is zero-indexed
  },
  onClearAll() {
    dispatch(clearAllAlerts())
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Alerts)
